import { CATEGORIES } from '@/utils/categoryConstants';

/**
 * Tailwind gradient utility classes per LOCI category id, used as the
 * EventCard media-slot fallback when `imageUrl` is null / empty / missing.
 *
 * Palette mirrors `eventCardCategoryBadge.ts` — same per-category accent
 * family scaled up to a softer 100→200 wash so the gradient reads as
 * editorial backdrop rather than a missing-asset placeholder.
 *
 * The `default` key is the muted treatment shared by EventCardCompact,
 * applied when the category is unknown or omitted.
 */
export const CATEGORY_GRADIENT_CLASSES: Record<string, string> = {
  music: 'bg-gradient-to-br from-purple-100 to-purple-200',
  sports: 'bg-gradient-to-br from-orange-100 to-orange-200',
  food: 'bg-gradient-to-br from-green-100 to-green-200',
  tech: 'bg-gradient-to-br from-blue-100 to-blue-200',
  art: 'bg-gradient-to-br from-pink-100 to-pink-200',
  drinks: 'bg-gradient-to-br from-yellow-100 to-yellow-200',
};

const DEFAULT_GRADIENT_CLASS = 'bg-gradient-to-br from-muted to-muted/70';

/**
 * Resolve the gradient utility classes for the given category id.
 * Falls back to a muted gradient when the id is unknown — matching the
 * `EventCardCompact` empty-image treatment for visual consistency.
 */
export function categoryGradientClass(cat: string): string {
  const normalized = cat.toLowerCase();
  if (!CATEGORIES.some((c) => c.id === normalized)) return DEFAULT_GRADIENT_CLASS;
  return CATEGORY_GRADIENT_CLASSES[normalized] ?? DEFAULT_GRADIENT_CLASS;
}
